import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import Addpopup from '../../component/Addpopup';

export default function KitchenPriceCalculator({ data }) {
   const [open, setOpen] = useState(false);

   const handleOpen = ()=>{
      setOpen(true);
   }

   const settingskey = {
      autoplay: true,
      speed: 1500,
      infinite: true,
      arrows: false,
      dots: true,
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,

      responsive: [
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 2,
            },
         },

         {
            breakpoint: 767,
            settings: {
               slidesToShow: 1,
            },
         },

         {
            breakpoint: 599,
            settings: {
               slidesToShow: 1,
            },
         },

         {
            breakpoint: 99999,
            settings: "unslick",
         },
      ],
   };

   return (
      <>
         <Addpopup addPopShow={open} setAddPopShow={setOpen} headingText={"How much will your modular kitchen cost?"} paraText={"Share a few details - our team will send you a budget estimate within 2 hours."} btnText={"Get My Estimate Cost"}/>
         <section className='kitchenpricecal-area'>
            <div className='container'>

               <div className='row justify-content-center'>
                  <div className='col-lg-10'>
                     <h4 className='heading'>{data.heading}</h4>
                     <p>{data.description}</p>
                  </div>
               </div>

               <Slider {...settingskey} className='row price-slider'>

                  {
                     data.plans.map((item, index) => (
                        <div
                           className='col-lg-4 col-md-6'
                           key={index}
                        >

                           <div className='kitchenpricecal-card'>

                              <span>{item.tag}</span>

                              <h4 className='heading'>
                                 {item.title}
                              </h4>

                              <ul>
                                 {
                                    item.features.map((feature, featureIndex) => (
                                       <li key={featureIndex}>
                                          <label>{feature.title}</label>
                                          {feature.text}
                                       </li>
                                    ))
                                 }
                              </ul>

                              <Link onClick={handleOpen} className="default-btn colored-btn">
                                 Explore Package
                                 <Icons name="Longarrow_right" />
                              </Link>

                           </div>

                        </div>
                     ))
                  }

               </Slider>

            </div>

         </section>
      </>
   )
}